// small to big layouts i.e default layout is for mobile phones
export const MEDIA_Q = {
  SM: "@media (min-width: 576px)", // landscape mobile phones
  MD: "@media (min-width: 768px)", // tablets
  LG: "@media (min-width: 992px)", // normal desktops
  XL: "@media (min-width: 1200px)", // large desktops
  XXL: "@media (min-width: 1400px)", // larger desktops
};